export default __webpack_public_path__ + "static/media/Shendoh of Ardent Fire.c065ad6b.jpg";